function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Big/LowSun");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "styleguide",
  transform: "translate(-276.000000, -713.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Big/LowSun",
  transform: "translate(275.000000, 712.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.3481013,48.7658228 L34.3481013,67 L32.6518987,67 L32.6518987,48.7658228 L34.3481013,48.7658228 Z M46.8207873,43.9254544 L58.6356861,55.7403532 L57.4364709,56.9395684 L45.6215722,45.1246696 L46.8207873,43.9254544 Z M20.1792127,44.7735557 L21.3784278,45.9727709 L10.4116304,56.9395684 L9.21241519,55.7403532 L20.1792127,44.7735557 Z M33.5,19.9303797 C40.5146456,19.9303797 46.221519,25.6372532 46.221519,32.6518987 C46.221519,39.6665443 40.5146456,45.3734177 33.5,45.3734177 C26.4853544,45.3734177 20.778481,39.6665443 20.778481,32.6518987 C20.778481,25.6372532 26.4853544,19.9303797 33.5,19.9303797 Z M33.5,21.6265823 C27.4208101,21.6265823 22.4746835,26.5727089 22.4746835,32.6518987 C22.4746835,38.7310886 27.4208101,43.6772152 33.5,43.6772152 C39.5791899,43.6772152 44.5253165,38.7310886 44.5253165,32.6518987 C44.5253165,26.5727089 39.5791899,21.6265823 33.5,21.6265823 Z M16.5379747,32.6518987 L16.5379747,34.3481013 L-3.73034936e-14,34.3481013 L-3.73034936e-14,32.6518987 L16.5379747,32.6518987 Z M67,32.6518987 L67,34.3481013 L49.6139241,34.3481013 L49.6139241,32.6518987 L67,32.6518987 Z M56.5887089,8.36397468 L57.7879241,9.56318987 L45.9730253,21.3780886 L44.7738101,20.1788734 L56.5887089,8.36397468 Z M11.2593924,8.36397468 L22.6502405,19.7548228 L21.4510253,20.954038 L10.0601772,9.56318987 L11.2593924,8.36397468 Z M34.3481013,0 L34.3481013,16.5379747 L32.6518987,16.5379747 L32.6518987,0 L34.3481013,0 Z",
  id: "Combined-Shape"
})))));

var SvgLowSun = function SvgLowSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "67px",
    viewBox: "0 0 67 67",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLowSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/low-sun.11d4eea7.svg";
export { ForwardRef as ReactComponent };